import { render, staticRenderFns } from "./crudConfigurations.vue?vue&type=template&id=0251531e&scoped=true&"
import script from "./crudConfigurations.vue?vue&type=script&lang=js&"
export * from "./crudConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./crudConfigurations.vue?vue&type=style&index=0&id=0251531e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251531e",
  null
  
)

export default component.exports